import type { ReactNode } from "react";

import styles from "../illustration.module.scss";

/** Losango arredondado do Figma (`rhombus-decorative`), centrado em (cx, cy). */
export function Diamond({ cx, cy, size = 8.94 }: { cx: number; cy: number; size?: number }) {
  return (
    <rect
      className={styles.fillSurface100}
      x={cx - size / 2}
      y={cy - size / 2}
      width={size}
      height={size}
      rx="1.57"
      transform={`rotate(45 ${cx} ${cy})`}
    />
  );
}

/** Cruz decorativa (`plus`), centrada em (cx, cy). */
export function Plus({
  cx,
  cy,
  arm = 3.53,
  width = 1.57,
}: {
  cx: number;
  cy: number;
  arm?: number;
  width?: number;
}) {
  return (
    <path
      className={styles.strokeSurface100}
      d={`M${cx - arm} ${cy}h${arm * 2}M${cx} ${cy - arm}v${arm * 2}`}
      strokeWidth={width}
      strokeLinecap="round"
    />
  );
}

/** Anel decorativo (`circle-decorative`), centrado em (cx, cy). */
export function Ring({
  cx,
  cy,
  r = 3.53,
  width = 1.57,
}: {
  cx: number;
  cy: number;
  r?: number;
  width?: number;
}) {
  return <circle className={styles.strokeSurface100} cx={cx} cy={cy} r={r} strokeWidth={width} />;
}

/** Moldura 216×113 dos estados vazios: círculo fantasma, disco com sombra e adornos; `Mark` é o ícone. */
export function StateFrame({
  children,
}: {
  children: (props: {
    x: number;
    y: number;
    stroke: string | undefined;
    fill: string | undefined;
  }) => ReactNode;
}) {
  return (
    <>
      <circle className={styles.strokeSurface100Fill50} cx="107" cy="72" r="41" />
      {children({ x: 87, y: 52, stroke: styles.strokeSurface100, fill: styles.fillSurface100 })}
      <Diamond cx={6.32} cy={20.37} />
      <Diamond cx={174.65} cy={104.94} />
      <Plus cx={22.77} cy={10.53} />
      <Plus cx={168.48} cy={31.67} />
      <Ring cx={141.07} cy={12.1} />
      <Ring cx={32.5} cy={107.62} />
      <circle
        className={`${styles.fillSurface0} ${styles.shadowIllustration}`}
        cx="80"
        cy="40"
        r="40"
      />
      {children({ x: 60, y: 20, stroke: styles.strokePrimary700, fill: styles.fillPrimary700 })}
    </>
  );
}
